<div class="row">
  <div class='col-lg-6 info-row'>
    <div class='info-column'>
      <div class='info-section'>
        <div class='info-list-2'>
          <info-list-item label='Name' [lock]="isFreemium" [value]='data?.publisherOverview?.name'
            [valueTooltip]='data?.publisherOverview?.name'
            (interact)='isAppDiscoveryEnabled && goToAppDiscovery("developerName", data?.publisherOverview?.name)'>
          </info-list-item>

          <info-list-item label='Location' labelTooltip='The business address of the developer' [lock]="isFreemium"
            [value]='data?.publisherOverview?.location'></info-list-item>

          <info-list-item label='Email Address' [lock]='isFreemium' [value]='data?.publisherOverview?.contactEmail'>
          </info-list-item>

          <info-list-item label='Country' [lock]="isFreemium" [valueTooltip]='data?.publisherOverview?.country'
            [value]='data?.publisherOverview?.country === "N/A" ? "N/A" : (data?.publisherOverview?.country | capitalize)'>
          </info-list-item>

          <info-list-item label='Website' [lock]="isFreemium"
            [valueTooltip]='data?.appOverview?.publisherDomain != "N/A" ? data?.appOverview?.publisherDomain : null'
            [link]='data?.appOverview?.publisherDomain != "N/A" ? data?.appOverview?.publisherDomain : null'
            [value]='data?.appOverview?.publisherDomain === "N/A" ? "N/A" : "Go to Website"'></info-list-item>

          <info-list-item label='Total Apps' [lock]='isFreemium'
            (labelInteract)='isAppDiscoveryEnabled ? goToAppDiscovery("developerName", data?.publisherOverview?.name) : null'
            [value]='data?.publisherOverview?.totalApps'></info-list-item>
        </div>
      </div>
    </div>
  </div>
  <div class='col-lg-6 info-row'>
    <div class='info-column'>
      <div class='info-section'>
        <div class='info-list-2'>
          <div class="divider d-lg-none"></div>
          <info-list-item label='WHOIS Info Hidden' [lock]="isFreemium"
            labelTooltip='Businesses with privately registered anonymous domains are flagged as high risk'
            [value]='data?.publisherOverview?.isPrivateDomain | yesno:"capitalize"'
            valueIcon='/assets/images/icon-indicator-{{data?.publisherOverview?.isPrivateDomain | yesno:"rev"}}-2.svg'>
          </info-list-item>

          <info-list-item label='Terms and Conditions Detected'
            labelTooltip='Businesses without published terms and conditions are flagged as high risk'
            [lock]='isFreemium'
            valueIcon='/assets/images/icon-indicator-{{data?.publisherOverview?.hasTermsOfServiceLink | yesno}}-2.svg'
            [value]='data?.publisherOverview?.hasTermsOfServiceLink | yesno:"capitalize"'></info-list-item>

          <info-list-item label='Privacy Policy Detected'
            labelTooltip='Businesses without a privacy policy are flagged as high risk' [lock]="isFreemium"
            [suggestionConfig]='{ type: "app", id: data?.appOverview?.appId, metricId: "publisherOverview.hasPrivacyLink" }'
            valueIcon='/assets/images/icon-indicator-{{data?.publisherOverview?.hasPrivacyLink | yesno}}-2.svg'
            [value]='data?.publisherOverview?.hasPrivacyLink | yesno:"capitalize"'></info-list-item>

          <info-list-item label='Facebook' labelTooltip='Low social media engagment on Facebook can be a risk factor'
            [lock]="isFreemium"
            [suggestionConfig]='{ type: "app", id: data?.appOverview?.appId, metricId: "socialMediaEngagement.facebookRating" }'
            valueIcon='/assets/images/icon-meter-{{data?.socialMediaEngagement?.facebookRating}}-white.svg'
            [value]='data?.socialMediaEngagement?.facebookRating'></info-list-item>

          <info-list-item label='LinkedIn' labelTooltip='Low social media engagment on LinkedIn can be a risk factor'
            [lock]="isFreemium"
            [suggestionConfig]='{ type: "app", id: data?.appOverview?.appId, metricId: "socialMediaEngagement.linkedInRating" }'
            valueIcon='/assets/images/icon-meter-{{data?.socialMediaEngagement?.linkedInRating}}-white.svg'
            [value]='data?.socialMediaEngagement?.linkedInRating'></info-list-item>

          <info-list-item label='Twitter' labelTooltip='Low social media engagment on Twitter can be a risk factor'
            [lock]="isFreemium"
            (labelInteract)='isAppDiscoveryEnabled ? goToAppDiscovery("twitterRating", data?.socialMediaEngagement?.twitterRating) : null'
            [suggestionConfig]='{ type: "app", id: data?.appOverview?.appId, metricId: "socialMediaEngagement.twitterRating" }'>
            <risk-heat-meter #value [risk]='data?.socialMediaEngagement?.twitterRating'></risk-heat-meter>
          </info-list-item>
        </div>
      </div>
    </div>
  </div>
</div>
<app-follow-unlock label="Additional Developer Details" (followClick)="follow()" *ngIf="!isFollowing && isFreemium">
</app-follow-unlock>